module.exports = __webpack_public_path__ + "static/img/case_detail_09_3.d7d80db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_09_3.png
// module id = Sb5G
// module chunks = 34